import React, { Children, useState } from "react";
import {
  Categories,
  DiscountAvailable,
  SelectedOulet,
  StoreData,
  imagePlaceHolder,
  setCustomerLoyaltyPoints,
} from "../../utils";
import BlockBussinessImage from "./BlockBussinessImage";
import { useTranslation } from "react-i18next";
import { homeStyles } from "../../styles";
import BlockBussinessName from "./BlockBussinessName";
import Loyalty from "../../../../shared/components/Loyalty";
import LoyaltyModal from "../../../../shared/components/LoyaltyModal";
import { useScrollLock } from "../../../../hooks/useScrollLock";
import DisplayDiscountMessage from "../../../../shared/components/DisplayDiscountMessage";
interface Props {
  useData: StoreData | undefined;
  categories: Categories[];
  preorderCategories: Categories[];
  hideMenuCategories: (path: string | undefined, preOrder?: boolean) => void;
  selectedLanguageCode: any;
  orderType: string | undefined;
  selectedOutlet: SelectedOulet;
  bussinessName: string;
  onPressLanguage: (item: any) => void;
  discountAvailable: DiscountAvailable;
  showPreOrder: boolean;
}
const BlockAllCategories: React.FC<Props> = (props: Props) => {
  const {
    useData,
    categories,
    preorderCategories,
    selectedLanguageCode,
    selectedOutlet,
    bussinessName,
    hideMenuCategories,
    onPressLanguage,
    discountAvailable,
    showPreOrder,
  } = props;
  const { t } = useTranslation();
  const showLoyaltyModalHandler = () => {
    lockScroll();
    setShowLoyaltyModal(true);
  };
  const { lockScroll, unlockScroll } = useScrollLock();
  const [showLoyaltyModal, setShowLoyaltyModal] = useState<boolean>(false);
  const hideLoyaltyModalHandler = () => {
    setShowLoyaltyModal(false);
    unlockScroll();
  };
  const RenderCategoriesBlock = ({ index, item, isPreOrder }: any) => (
    <div
      onClick={() => {
        if (isPreOrder) {
          hideMenuCategories(`list-item${index}`, true);
        } else {
          hideMenuCategories(`list-item${index}`);
        }
      }}
      style={{
        width: "42%",
        marginRight: 26,
        marginBottom: 39,
      }}
    >
      <div key={index}>
        <div>
          {
            <div style={{ marginBottom: 6 }}>
              <div
                style={{
                  backgroundImage: `url(${
                    null !== item?.category_image
                      ? item?.category_image
                      : imagePlaceHolder
                  })`,
                }}
                className={
                  "box_shadow round_cor_grid_view backkground-image-style product_img_heigth_width"
                }
              />
            </div>
          }
          <div className="">
            <div>
              <div
                className=" limit-two-lines categoryName"
                dangerouslySetInnerHTML={{
                  __html: item.name[selectedLanguageCode],
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  return (
    <div
      id="ALL_CATEGORIES"
      className="pop_up_maps_main pop_main_menu_bg"
      lang={selectedLanguageCode}
    >
      <div className="popup_delivery popup_from_bottom pop_up_all_categories popup_slide ">
        <BlockBussinessImage
          useData={useData}
          hideBussinessName={true}
          selectedLanguageCode={selectedLanguageCode}
          selectedOutlet={selectedOutlet}
          onPressLanguage={onPressLanguage}
          bussinessName={bussinessName!}
        />

        <div className="all_categories_linear_backgroung">
          <BlockBussinessName
            selectedLanguageCode={selectedLanguageCode}
            useData={useData}
            selectedOutlet={selectedOutlet}
          />
          {discountAvailable.available && !showPreOrder && (
            <div className="loyalty-wrapper">
              <DisplayDiscountMessage
                showIcon={true}
                message={
                  //@ts-ignore
                  useData?.discounts?.discount_name[selectedLanguageCode]
                }
              />
            </div>
          )}
          {useData?.loyalties !== null && (
            <div className="loyalty-wrapper " onClick={showLoyaltyModalHandler}>
              <Loyalty
                setUserLoyaltyPoints={(points) =>
                  setCustomerLoyaltyPoints(points, bussinessName!)
                }
                makeApiCall={true}
                title={t("lbl_loyalty_disp_heading")}
                message={t("lbl_loyalty_disp_desc").replace(
                  "{#cashback}",
                  `${useData?.loyalties.cash_back.with_percentage}`
                )}
                // message={`Earn ${useData?.loyalties.cash_back.with_percentage} cashback to spend in your next orders.`}
                showIcon
              />
            </div>
          )}
          <div className="food_categories_title ">{t("delivery_pickup")}</div>
          <div style={homeStyles.flexWrap}>
            {categories &&
              categories.map((item, index) => {
                return <RenderCategoriesBlock item={item} index={index} />;
              })}
          </div>
          {preorderCategories && preorderCategories.length > 0 && (
            <div
              className="food_categories_title "
              style={{ marginBottom: 10, marginTop: 0 }}
            >
              {t("preorder")}
            </div>
          )}
          {useData && showLoyaltyModal && (
            <LoyaltyModal
              onPressClose={hideLoyaltyModalHandler}
              loyalties={useData?.loyalties}
              selectedLang={selectedLanguageCode}
            />
          )}
          <div style={homeStyles.flexWrap}>
            {preorderCategories &&
              preorderCategories.map((item, index) => {
                return (
                  <RenderCategoriesBlock
                    item={item}
                    index={index}
                    isPreOrder={true}
                  />
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockAllCategories;
